import axios from 'axios';
import { generateHttpActions } from '../../../../utility';

function userTrialsFilterCheckHttpRequest() {
  const httpActions = generateHttpActions('userTrialsFilterCheck');
  const resource = 'trial-management/trials-user-filter-status';

  return async (dispatch) => {
    dispatch(httpActions.start());
    try {
      const response = await axios.get(resource);

      dispatch(httpActions.success(response.data));
    } catch (error) {
      dispatch(httpActions.error(error));
    }
  };
}

export default userTrialsFilterCheckHttpRequest;
